module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.8984/img/provider-signup/community-creators-blobs.png"